import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  getSessionsSummary,
  type SessionSummary,
  type SessionsSummaryParams,
  type SessionsSummaryResponse,
} from '../services/api/sessions';

export function useSessions(params: SessionsSummaryParams) {
  const { fromDate, toDate, fromTime, toTime, includePlayground, includeEmpty } = params;

  const { data, isLoading, isFetching, error, refetch } = useQuery<SessionsSummaryResponse>({
    queryKey: [
      'sessions',
      fromDate ?? null,
      toDate ?? null,
      fromTime ?? null,
      toTime ?? null,
      includePlayground ?? false,
      includeEmpty ?? false,
    ],
    queryFn: () => getSessionsSummary(params),
    enabled: false,
    staleTime: 0,
    retry: false,
  });

  const sync = useCallback(async () => {
    return refetch({ cancelRefetch: true });
  }, [refetch]);

  return {
    sessions: data?.sessions ?? [],
    unavailableReason: data?.unavailableReason ?? null,
    total: data?.total ?? null,
    truncated: data?.truncated ?? false,
    isLoading,
    isFetching,
    error: error as Error | null,
    sync,
  };
}

export type { SessionSummary };
